import { ModalCloseButton } from '@/components/Modals/ModalV2/ModalCloseButton'
import Field from '@/components/Field'
import RoundedBox from '@/components/RoundedBox'
import Separator from '@/components/Separator'

const PinSettings = ({ isOpen, settings, onChange, onClose }) => {
  if (!isOpen) return null

  const { anchorX, anchorY, positionX, positionY } = settings

  return (
    <RoundedBox className="fixed z-confirm bottom-0 md:bottom-4 md:right-4 w-full md:w-[500px] grid grid-cols-2 gap-4 bg-gray-800/95">
      <div className="flex flex-col gap-1">
        <ModalCloseButton
          onClick={onClose}
          className="absolute -left-1 -top-1 !bg-gray-600"
        />
        <h2 className="h5">Anchor</h2>
        <Separator />
        <Field name={'anchor.x'} label={`X : ${anchorX}`}>
          <input
            type="range"
            min="0"
            max="100"
            step="1"
            defaultValue={anchorX}
            className="w-full"
            onChange={e =>
              onChange({
                name: 'anchorX',
                value: Number(e.target.value)
              })
            }
          />
        </Field>
        <Field name={'anchor.y'} label={`Y : ${anchorY}`}>
          <input
            type="range"
            min="0"
            max="100"
            step="1"
            defaultValue={anchorY}
            className="w-full"
            onChange={e =>
              onChange({
                name: 'anchorY',
                value: Number(e.target.value)
              })
            }
          />
        </Field>
      </div>
      <div className="flex flex-col gap-1">
        <h2 className="h5">Position</h2>
        <Separator />
        <Field name={'position.x'} label={`X : ${positionX}`}>
          <input
            type="range"
            min="-100"
            max="200"
            step="1"
            defaultValue={positionX}
            className="w-full"
            onChange={e =>
              onChange({
                name: 'positionX',
                value: Number(e.target.value)
              })
            }
          />
        </Field>
        <Field name={'position.y'} label={`Y : ${positionY}`}>
          <input
            type="range"
            min="-100"
            max="200"
            step="1"
            defaultValue={positionY}
            className="w-full"
            onChange={e =>
              onChange({
                name: 'positionY',
                value: Number(e.target.value)
              })
            }
          />
        </Field>
      </div>
    </RoundedBox>
  )
}

export default PinSettings
